let loadPromise = null;
export let mapsAuthFailed = false;

window.gm_authFailure = () => {
  mapsAuthFailed = true;
  window.dispatchEvent(new Event('gmaps-auth-failure'));
};

export const loadGoogleMaps = () => {
  if (window.google?.maps?.places) return Promise.resolve(window.google.maps);
  if (loadPromise) return loadPromise;
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  loadPromise = new Promise((resolve, reject) => {
    if (!key) return reject(new Error('Google Maps key missing'));
    window.__gmapsInit = () => resolve(window.google.maps);
    const s = document.createElement('script');
    s.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&loading=async&callback=__gmapsInit`;
    s.async = true;
    s.onerror = () => { loadPromise = null; reject(new Error('Google Maps failed to load')); };
    document.head.appendChild(s);
  });
  return loadPromise;
};

export const geocodeAddress = async (query) => {
  const maps = await loadGoogleMaps();
  const geocoder = new maps.Geocoder();
  const { results } = await geocoder.geocode({ address: query, region: 'in' });
  return results?.[0] || null;
};

export const reverseGeocode = async (lat, lng) => {
  const maps = await loadGoogleMaps();
  const geocoder = new maps.Geocoder();
  const { results } = await geocoder.geocode({ location: { lat, lng } });
  return results?.[0] || null;
};

export const extractAddressParts = (result) => {
  const parts = { city: '', state: '', pincode: '', locality: '' };
  if (!result) return parts;
  for (const c of result.address_components || []) {
    if (c.types.includes('locality')) parts.city = c.long_name;
    else if (!parts.city && c.types.includes('administrative_area_level_2')) parts.city = c.long_name;
    if (c.types.includes('administrative_area_level_1')) parts.state = c.long_name;
    if (c.types.includes('postal_code')) parts.pincode = c.long_name;
    if (c.types.includes('sublocality_level_1') || c.types.includes('sublocality')) parts.locality = parts.locality || c.long_name;
  }
  return parts;
};

export const mapsSearchUrl = (lat, lng) => `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
export const mapsDirectionsUrl = (lat, lng) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
